module.exports = __webpack_public_path__ + "assets/img/11_480_big.58b65073.jpg";